/**
 * Whether a tracker has at least one ENABLED automation rule and no live event
 * stream.
 *
 * Board cell mutations use this to decide whether to schedule a delayed
 * re-fetch (automations run in a background worker AFTER the edit's response,
 * so the board would otherwise only reflect them on a manual refresh). Once
 * the server confirms the board's stream is subscribed it reports each result
 * itself, so the timers only cover the time it is not. Reads
 * the shared `trackerAutomationsQueryOptions` cache that `AutomationsButton`
 * already populates, so it adds no extra network on boards where the header is
 * mounted; disabled entirely when the tracker id is empty.
 */
import { useQuery } from '@tanstack/react-query';

import { trackerAutomationsQueryOptions } from '@/entities/tracker-automation';

import { useTrackerStreamLive } from './trackerEventStream';

export function useHasEnabledAutomations(trackerId: string): boolean {
  const { data } = useQuery({
    ...trackerAutomationsQueryOptions(trackerId),
    enabled: Boolean(trackerId),
  });
  const live = useTrackerStreamLive(trackerId);
  return !live && (data ?? []).some((rule) => rule.enabled);
}
